import React, { useState, useEffect } from "react";

import UnionIcon from "../../../assets/images/icons/Union_5.svg";
import { useTranslation } from "react-i18next";
import AdminDiamondCutComp from "../../AdminChartsGroup/AdminDiamondCutComp";
import AdminDiamondShapeComp from "../../AdminChartsGroup/AdminDiamondShapeComp";
import AdminDiamondClarityComp from "../../AdminChartsGroup/AdminDiamondClarityComp";
import AdminDiamondCertificateComp from "../../AdminChartsGroup/AdminDiamondCertificateComp";
import moment from "moment";
import { useSelector } from "react-redux";
import AdminDiamondReportService from "../../../services/reports-AdminDiamond-service";
import AdminDiamondCutGradeComp from "../../AdminChartsGroup/AdminDiamondCutGradeComp";
import AdminDiamondColorSearchesComp from "../../AdminChartsGroup/AdminDiamondColorSearchesComp";
import AdminDiamondSizeSearchesComp from "../../AdminChartsGroup/AdminDiamondSizeSearchesComp";
import AdminDiamondPriceComp from "../../AdminChartsGroup/AdminDiamondPriceComp";
import GlobalDiamondReportService from "../../../services/reports-globalDiamond-service";
import { DatePicker, Select, Tooltip, Spin } from "antd";
import DiamondCutComp from "../../ChartsGroup/DiamondCutComp";
import DiamondReportsClicksComp from "../../ChartsGroup/DiamondReportsCharts/DiamondReportsClicksComp";
const { RangePicker } = DatePicker;
const { Option } = Select;

const ExtendedDiamondChartReports = () => {
  const { t } = useTranslation();
  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleCheckDealermembers(
            loginDetials.loginDetials.responseData.dealerId
          );
        }
      }
    }
    handleGetVendorDropdownData();
    handleGetRetailerDropdownData();
  }, []);

  const initialGlobalDiamondState = {
    dataRangeFrom: moment().subtract(30, "days").format("YYYY-MM-DD"),
    dataRangeTo: moment().format("YYYY-MM-DD"),
    SelectedDiamondValue: "All",
    retailerIds: [],
    vendorIds: [],
  };
  const [dealerId, setDealerId] = useState();
  const loginDetials = useSelector((state) => state.loginReducer);
  const [forDealer, setForDealer] = useState("");
  const [LoadChartReportsLoading, setLoadChartReportsLoading] = useState(false);
  const [TotalDiamondClicks, setTotalDiamondClicks] = useState(0);
  const [globalDiamonds, setGlobalDiamond] = useState(
    initialGlobalDiamondState
  );
  const [isApplyFilter, setIsApplyFilter] = useState(false);
  const [vendorList, setVendorList] = useState([]);
  const [retailerList, setRetailerList] = useState([]);

  const [chartData, setChartData] = useState([]);
  const [colorData, setColorData] = useState([]);

  const onDateChange = (dates, dateStrings) => {
    if (dates) {
      setGlobalDiamond((prevState) => ({
        ...prevState,
        dataRangeFrom: dateStrings[0],
        dataRangeTo: dateStrings[1],
      }));
    }
  };

  const handleCheckDealermembers = (id) => {
    let inputData = {
      dealerID: id,
    };
    AdminDiamondReportService.CheckDealermembers(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        var forDealer = responseData.forDealer;
        console.log(JSON.stringify(response), "handleCheckDealermembers");
        if (message === "Success") {
          if (Object.keys(responseData).length !== 0) {
            setForDealer(forDealer);
          } else {
            setForDealer("");
          }
          handleLoadChartReports(id, forDealer);
        } else {
          setForDealer("");
        }
      })
      .catch((error) => {
        console.log(error);
        setForDealer("");
      });
  };

  const handleLoadChartReports = (dealerId, forDealer) => {
    let inputData = {
      dealerID: dealerId.toString(),
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: globalDiamonds.dataRangeFrom
        ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
        : "2020-08-17",
      toDate: globalDiamonds.dataRangeTo
        ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
        : "2022-09-15",
      retailerIds: globalDiamonds.retailerIds.toString(),
      vendorIds: globalDiamonds.vendorIds.toString(),
      selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
      type: "Global",
      reportName: "ExtDiamondChrt",
    };
    setLoadChartReportsLoading(true);

    AdminDiamondReportService.LoadChartReports(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        var TotalDiamondClicks =
          responseData.TotalDiamondClicks[0].TotalClickCnt;
        if (message === "Success") {
          if (Object.keys(responseData).length !== 0) {
            setTotalDiamondClicks(TotalDiamondClicks);
          }
        } else {
          setTotalDiamondClicks([]);
        }
      })
      .catch((error) => {
        setLoadChartReportsLoading(false);
        setTotalDiamondClicks([]);
      })
      .finally(() => setLoadChartReportsLoading(false));
  };

  const handleOnChange = (e, isSelect, name) => {
    let vId = "";
    let rId = "";
    if (isSelect === "select" && name === "vendors") {
      vId = e.includes(0) ? [0] : e;
      setGlobalDiamond((prevState) => {
        const updatedState = { ...prevState, vendorIds: vId };
        if (
          updatedState.vendorIds.length === 0 &&
          updatedState.retailerIds?.length === 0
        ) {
          handleGetVendorDropdownData();
          handleGetRetailerDropdownData();
        } else {
          changeRetailerListHandler(vId);
        }

        return updatedState;
      });
    } else if (isSelect === "select" && name === "retailers") {
      rId = e.includes(0) ? [0] : e;
      setGlobalDiamond((prevState) => {
        const updatedState = { ...prevState, retailerIds: rId };
        if (
          updatedState.vendorIds?.length === 0 &&
          updatedState.retailerIds.length === 0
        ) {
          handleGetVendorDropdownData();
          handleGetRetailerDropdownData();
        } else {
          changeVendorListHandler(rId);
        }

        return updatedState;
      });
    } else {
      setGlobalDiamond((prevState) => ({
        ...prevState,
        [name]: e,
      }));
    }
  };

  const handleGetVendorDropdownData = () => {
    GlobalDiamondReportService.GetVendors()
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          if (Object.keys(responseData).length !== 0) {
            setVendorList(responseData.Table);
          }
        } else {
          setVendorList([]);
        }
      })
      .catch((error) => {
        setVendorList([]);
      });
  };

  const handleGetRetailerDropdownData = () => {
    GlobalDiamondReportService.GetRetailers()
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          if (Object.keys(responseData).length !== 0) {
            setRetailerList(responseData.Table);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        setRetailerList([]);
      });
  };

  const changeRetailerListHandler = (data) => {
    data = data.toString();
    let inputData = {
      vendorsID: data,
    };
    GlobalDiamondReportService.GetRetailersOnVendorDropdownChange(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          if (Object.keys(responseData).length !== 0) {
            setRetailerList(responseData.retailers);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        setRetailerList([]);
      });
  };
  const changeVendorListHandler = (data) => {
    data = data.toString();
    let inputData = {
      retailerID: data,
    };
    GlobalDiamondReportService.GetVendorsOnRetailerDropdownChange(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          if (Object.keys(responseData).length !== 0) {
            if (responseData.vendors !== null) {
              setVendorList(responseData.vendors);
            }
          }
        } else {
          setVendorList([]);
        }
      })
      .catch((error) => {
        console.log(error);
        setVendorList([]);
      });
  };

  const handleApplyFilter = () => {
    handleCheckDealermembers(dealerId);
    setIsApplyFilter(!isApplyFilter);
  };


  const options = {
    is3D: true,
    pieHole: 0.5,
    pieSliceText: "percentage",
    tooltip: { trigger: "focus", text: "text" },
    chartArea: { left: "10%", top: "5%", width: "80%", height: "90%" },
    colors: colorData,
    legend: { position: "none" },
  }

  return (
    <React.Fragment>
      <div className="pendjewelreq__section form__fields">
        <div className="row magento__mapping">
          <div className="col-md-12">
            <div className="heading__block">
              <h4 class="workarea__heading mt-0 mb-0">
                {t("Extended Diamond Chart Reports")}
              </h4>
            </div>
          </div>
          <div className="col-md-4">
            <div className="input__block dataRange-input-block datepicker__block">
              <label> {t("Date Range")} </label>
              <RangePicker
                className="date-range-input"
                ranges={{
                  Today: [moment(), moment()],
                  Yesterday: [
                    moment().subtract(1, "days"),
                    moment().subtract(1, "days"),
                  ],
                  "Last 7 Days": [moment().subtract(7, "days"), moment()],
                  "Last 30 Days": [moment().subtract(30, "days"), moment()],
                  "This Month": [
                    moment().startOf("month"),
                    moment().endOf("month"),
                  ],
                  "Last Month": [
                    moment().subtract(1, "month").startOf("month"),
                    moment().subtract(1, "months").endOf("month"),
                  ],
                  "Last 90 Days": [moment().subtract(90, "days"), moment()],
                  "Year To Date": [moment().startOf("year"), moment()],
                }}
                format={"MM-DD-YYYY"}
                onChange={onDateChange}
                defaultValue={[moment().subtract(30, "days"), moment()]}
                defaultPickerValue={[moment().subtract(30, "days"), moment()]}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="input__block">
              <label> {t("Select Diamond")} </label>
              <Select
                className="border__grey"
                placeholder={t("All")}
                showSearch
                name="SelectedDiamondValue"
                optionFilterProp="children"
                value={
                  globalDiamonds.SelectedDiamondValue
                    ? globalDiamonds.SelectedDiamondValue
                    : null
                }
                onChange={(e) =>
                  handleOnChange(e, "select", "SelectedDiamondValue")
                }
              >
                <Option value="All"> {t("All")} </Option>
                <Option value="Mined"> {t("Mined Diamond")} </Option>
                <Option value="Lab"> {t("Lab Grown Diamond")} </Option>
              </Select>
            </div>
          </div>

          <div className="col-md-4">
            <div className="input__block">
              <label> {t("Vendor(s)")} </label>
              <Select
                className="border__grey"
                showSearch
                mode="multiple"
                showArrow
                placeholder={t("Select one or more vendor")}
                optionFilterProp="children"
                value={globalDiamonds.vendorIds}
                onChange={(e) => handleOnChange(e, "select", "vendors")}
              >
                {vendorList.length > 0 &&
                  vendorList.map((item, key) => {
                    return (
                      <Option key={item.dealerID} value={item.dealerID}>
                        {" "}
                        {item.dealercompany}{" "}
                      </Option>
                    );
                  })}
              </Select>
            </div>
          </div>

          <div className="col-md-4">
            <div className="input__block">
              <label> {t("Retailer(s)")} </label>
              <Select
                showSearch
                showArrow
                className="border__grey"
                placeholder={t("Select one or more retailer ")}
                optionFilterProp="children"
                onChange={(e) => handleOnChange(e, "select", "retailers")}
                notFoundContent={t("No Data Found")}
                mode="multiple"
                value={globalDiamonds.retailerIds}
              >
                {retailerList.length > 0 &&
                  retailerList.map((item, key) => {
                    return (
                      <React.Fragment>
                        <Option key={item.dealerID} value={item.dealerID}>
                          {" "}
                          {item.dealercompany}{" "}
                        </Option>
                      </React.Fragment>
                    );
                  })}
              </Select>
            </div>
          </div>

          <div className="col-md-4">
            <div className="input__block">
              <button
                className="primary-btn mobile-mt-0"
                style={{ marginTop: 25 }}
                onClick={handleApplyFilter}
              >
                {t("Apply Filter")}
              </button>
            </div>
          </div>

          <div className="col-lg-12 col-md-6 mt-4 mobile-m-0">
            <div className="input__block">
              <label>
                <Spin spinning={LoadChartReportsLoading} size="small">
                  <b>
                    {t("Total Clicks")} :{" "}
                    {TotalDiamondClicks ? TotalDiamondClicks : 0}
                  </b>
                </Spin>
                <Tooltip
                  placement="right"
                  title={t(
                    "Displays the total number of jewelry clicks through the currently specified date range above"
                  )}
                >
                  <img src={UnionIcon} alt="" />
                </Tooltip>
              </label>
            </div>
          </div>
          <div className="col-lg-12 mt-4 mobile-m-0">
            <div className="chart__section">
              {forDealer && (
                <DiamondCutComp
                  globalDiamonds={globalDiamonds}
                  mainForDealer={forDealer}
                  isApplyFilter={isApplyFilter}
                />
              )}
            </div>
          </div>

          <div className="col-lg-12 mt-4">
            <div className="chart__section">
              {forDealer && (
                <AdminDiamondShapeComp
                  globalDiamonds={globalDiamonds}
                  mainForDealer={forDealer}
                  isApplyFilter={isApplyFilter}
                />
              )}
            </div>
          </div>

          <div className="col-lg-12 mt-4">
            <div className="chart__section">
              {forDealer && (
                <AdminDiamondClarityComp
                  globalDiamonds={globalDiamonds}
                  mainForDealer={forDealer}
                  isApplyFilter={isApplyFilter}
                />
              )}
            </div>
          </div>

          <div className="col-lg-12 mt-4">
            <div className="chart__section">
              {forDealer && (
                <AdminDiamondCertificateComp
                  globalDiamonds={globalDiamonds}
                  mainForDealer={forDealer}
                  isApplyFilter={isApplyFilter}
                />
              )}
            </div>
          </div>

          <div className="col-lg-12 mt-4">
            <div className="chart__section">
              {forDealer && (
                <AdminDiamondCutGradeComp
                  globalDiamonds={globalDiamonds}
                  mainForDealer={forDealer}
                  isApplyFilter={isApplyFilter}
                />
              )}
            </div>
          </div>

          <div className="col-lg-12 mt-4">
            <div className="chart__section">
              {forDealer && (
                <AdminDiamondColorSearchesComp
                  globalDiamonds={globalDiamonds}
                  mainForDealer={forDealer}
                  isApplyFilter={isApplyFilter}
                  options={options}
                  chartData={chartData}
                  setColorData={setColorData}

                  setChartData={setChartData}
                  colorData={colorData}
                />
              )}
            </div>
          </div>

          <div className="col-lg-12 mt-4">
            <div className="chart__section">
              {forDealer && (
                <AdminDiamondSizeSearchesComp
                  globalDiamonds={globalDiamonds}
                  mainForDealer={forDealer}
                  isApplyFilter={isApplyFilter}
                />
              )}
            </div>
          </div>

          <div className="col-lg-12 mt-4">
            <div className="chart__section">
              {forDealer && (
                <DiamondReportsClicksComp
                  globalDiamonds={globalDiamonds}
                  mainForDealer={forDealer}
                  isApplyFilter={isApplyFilter}
                />
              )}
            </div>
          </div>

          <div className="col-lg-12 mt-4">
            <div className="chart__section">
              {forDealer && (
                <AdminDiamondPriceComp
                  globalDiamonds={globalDiamonds}
                  mainForDealer={forDealer}
                  isApplyFilter={isApplyFilter}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ExtendedDiamondChartReports;
